<template>
    <span class="checkbox-wrapper">
        <input type="checkbox"
               :id="id"
               :checked="value"
               @change="change"
        />
        <span class="checkmark">
            <svg viewBox="0 0 20 15" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M18 2L7 13L2 8" stroke="white" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
        </span>
    </span>
</template>

<script>
    export default {
        name: "Checkbox",
        props: {
            id: String,
            value: {},
        },
        methods: {
            change(event) {
                this.$emit('input', event.target.checked)
            }
        }
    }
</script>

<style lang="scss" scoped>
    .checkbox-wrapper {
        display: inline-flex;
        align-items: center;
        cursor: pointer;
    }

    input[type=checkbox] {
        display: none;
    }

    .checkmark {
        box-sizing: border-box;
        position: relative;
        display: inline-block;
        width: 24px;
        height: 24px;

        background: #FCFCFC;
        border: 1px solid #D5D6D2;
        border-radius: 4px;

        cursor: pointer;

        svg {
            position: absolute;
            left: 50%;
            top: 50%;
            transform: translate(-50%, -50%);
            width: 16px;
            opacity: 0;
        }

        input[type=checkbox]:checked ~ & {
            background: #A2D100;

            &::after {
                opacity: 1;
            }

            svg {
                opacity: 1;
            }
        }

        .has-error & {
            background: #fff2f2;
            border-color: #de3831;
        }
    }

    .checkmark {
        margin-right: 8px;
    }
</style>
